import { basename } from "store";

/**
 * Normalizes paths to handle trailing slashes consistently
 * @param {string} path - The path to normalize
 * @returns {string} - The normalized path
 */
export const normalizePath = path => {
 
  const normalizedPath =
    path.endsWith('/') && path !== '/' ? path.slice(0, -1) : path;

  if (normalizedPath === `${basename}checkout-journey`) {
    return `/checkout-journey/`;
  }

  if (normalizedPath.startsWith(`${basename}checkout-journey/success`)) {
    return `/checkout-journey/success/`;
  }

  return normalizedPath;
};
